import React from 'react';
import isEmpty from 'lodash/isEmpty';
import classNames from 'classnames';
import styled from 'styled-components';
import { FormGroup, Label, Input } from 'reactstrap';

const Required = styled.span`
  color: rgba(231, 74, 59, 0.75);
`;

const renderField = ({
  input,
  placeholder,
  type,
  label,
  disabled,
  required,
  groupClass,
  className,
  meta: { touched, error, warning },
}) => (
  <FormGroup className={groupClass}>
    {!isEmpty(label) && (
      <Label>
        {label}
      </Label>
    )}
    {required && <Required>*</Required>}
    <Input
      {...input}
      placeholder={placeholder}
      type={type}
      className={classNames(className || '', {
        'is-invalid': touched && error,
      })}
      disabled={disabled}
    />
    {touched && ((error && <small className="invalid-feedback">{error}</small>) || (warning && <span>{warning}</span>))}
  </FormGroup>
);

export default renderField;
